import { render, staticRenderFns } from "./jihuakaiji.vue?vue&type=template&id=7d8d9008&"
import script from "./jihuakaiji.vue?vue&type=script&lang=js&"
export * from "./jihuakaiji.vue?vue&type=script&lang=js&"
import style0 from "./jihuakaiji.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports